var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.445312 19.776V16.2989H17.1785V19.776H0.445312ZM3.79195 12.8219H4.96327L11.4892 6.06346L10.297 4.82477L3.79195 11.605V12.8219ZM2.11863 14.5604V10.8661L11.4892 1.15217C11.6426 0.992802 11.8204 0.869658 12.0226 0.782732C12.2248 0.695807 12.4374 0.652344 12.6605 0.652344C12.8836 0.652344 13.0998 0.695807 13.3089 0.782732C13.5181 0.869658 13.7064 1.00005 13.8737 1.1739L15.0241 2.39085C15.1914 2.55022 15.3134 2.73856 15.3901 2.95587C15.4668 3.17319 15.5052 3.39774 15.5052 3.62954C15.5052 3.84686 15.4668 4.06055 15.3901 4.27062C15.3134 4.48069 15.1914 4.67265 15.0241 4.8465L5.67443 14.5604H2.11863Z",
    fill: "#276229"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconButton);
export default __webpack_public_path__ + "static/media/edit_icon-button.51b236c27da951a8bd36d78a342d87f9.svg";
export { ForwardRef as ReactComponent };